import { AnyAppEvent, AppEvent } from "../appEvent.types";

const eventName = "assign-badges" as const;

export type AssignBadgesEventData = {
  tickets: Array<{
    quantity: number;
    exhibitorId?: string | null;
    commercialId?: string | null;
    visitorId?: string | null;
  }>;
  eventId: string;
};
export type AssignBadgesEvent = AppEvent<
  typeof eventName,
  AssignBadgesEventData
>;

export const isAssignBadgesEvent = (
  event: AnyAppEvent
): event is AssignBadgesEvent => event.name === eventName;

export { eventName as assignBadges };
